module.exports = __webpack_public_path__ + "img/australia-digestive-diseases-male.fd566bb5.png";